import { saveMediaRecommendationPreferencesToCookie } from './media-recommendation-preferences-cookie-operations';
import { selectMediaOptions } from './media-recommendation-preferences-selectors';
import {
    resetMediaSourcesToDefaults,
    setDamMediaEnabled,
    setMediaGuidance,
    setMediaOptions,
    setMinimumStockSuitabilityScore,
    setMusicRecommendationMode,
    setSourceMediaEnabled,
    setStockIconsEnabled,
    setStockMediaEnabled,
    setWorkspaceFolderIds,
    setWorkspaceMediaMode,
} from './media-recommendation-preferences-slice';

import type {
    MediaOptions,
    MusicRecommendationModeEnum,
    WorkspaceMediaModeEnum,
} from 'js/src/client';
import type { AppDispatch, RootState } from 'js/src/libs/RootState';

export const updateSourceMediaEnabledOperation = (enabled: boolean) => {
    return (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(setSourceMediaEnabled(enabled));
        const mediaOptions = selectMediaOptions(getState());
        saveMediaRecommendationPreferencesToCookie(mediaOptions);
    };
};

export const updateStockMediaEnabledOperation = (enabled: boolean) => {
    return (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(setStockMediaEnabled(enabled));
        const mediaOptions = selectMediaOptions(getState());
        saveMediaRecommendationPreferencesToCookie(mediaOptions);
    };
};

export const updateStockIconsEnabledOperation = (enabled: boolean) => {
    return (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(setStockIconsEnabled(enabled));
        const mediaOptions = selectMediaOptions(getState());
        saveMediaRecommendationPreferencesToCookie(mediaOptions);
    };
};

export const updateDamMediaEnabledOperation = (enabled: boolean) => {
    return (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(setDamMediaEnabled(enabled));
        const mediaOptions = selectMediaOptions(getState());
        saveMediaRecommendationPreferencesToCookie(mediaOptions);
    };
};

export const updateWorkspaceMediaModeOperation = (mode: WorkspaceMediaModeEnum) => {
    return (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(setWorkspaceMediaMode(mode));
        const mediaOptions = selectMediaOptions(getState());
        saveMediaRecommendationPreferencesToCookie(mediaOptions);
    };
};

export const updateWorkspaceFolderIdsOperation = (folderIds: number[]) => {
    return (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(setWorkspaceFolderIds(folderIds));
        const mediaOptions = selectMediaOptions(getState());
        saveMediaRecommendationPreferencesToCookie(mediaOptions);
    };
};

export const updateMediaGuidanceOperation = (guidance: string) => {
    return (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(setMediaGuidance(guidance));
        const mediaOptions = selectMediaOptions(getState());
        saveMediaRecommendationPreferencesToCookie(mediaOptions);
    };
};

export const updateMinimumStockSuitabilityScoreOperation = (score: number | null) => {
    return (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(setMinimumStockSuitabilityScore(score));
        const mediaOptions = selectMediaOptions(getState());
        saveMediaRecommendationPreferencesToCookie(mediaOptions);
    };
};

export const updateMusicRecommendationModeOperation = (mode: MusicRecommendationModeEnum) => {
    return (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(setMusicRecommendationMode(mode));
        const mediaOptions = selectMediaOptions(getState());
        saveMediaRecommendationPreferencesToCookie(mediaOptions);
    };
};

export const updateMediaOptionsOperation = (updates: Partial<MediaOptions>) => {
    return (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(setMediaOptions(updates));
        const mediaOptions = selectMediaOptions(getState());
        saveMediaRecommendationPreferencesToCookie(mediaOptions);
    };
};

export const resetMediaSourcesToDefaultsOperation = () => {
    return (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(resetMediaSourcesToDefaults());
        const mediaOptions = selectMediaOptions(getState());
        saveMediaRecommendationPreferencesToCookie(mediaOptions);
    };
};
